import { useEffect } from 'react';
import { history } from '../../app/configureStore';

const usePushStateHandler = () => {
  useEffect(() => {
    const listener = (event) => {
      const target = event.target;
      if (target.getAttribute('data-pushstate')) {
        const domainTest = /http(s)?:\/\/(www\.)?matchbook\.com/;

        if (!target.getAttribute('href')) {
          return;
        }

        const href = target.getAttribute('href').replace(domainTest, '');

        const isExternal = /^http(s):\/\//.test(href);

        const protocol = `${event.protocol}//`;

        if (href.slice(protocol.length) !== protocol && !isExternal) {
          event.preventDefault();

          history.push(href);
        }
      }
    };

    document.addEventListener('click', listener);

    return () => {
      document.removeEventListener('click', listener);
    };
  }, []);
};

export default usePushStateHandler;

